import type { FC, PropsWithChildren, ReactElement } from 'react';

import { Modal } from '../modal/modal/Modal';

export interface SettingsModalProps extends PropsWithChildren {
  newLayout: boolean;
  heightAdjustment?: number;
  open: boolean;
  onClose: () => void;
  onBack?: () => void;
}

export const SettingsModal: FC<SettingsModalProps> = ({ children, ...rest }): ReactElement => (
  <Modal data-testid="settings-modal" draggable fullScreenNoClose originX="end" tk="SETTINGS" {...rest}>
    {children}
  </Modal>
);
